export default __webpack_public_path__ + "static/media/quoth_banner.9f14c580.jpeg";